/**
 * A simple cache for promises. Helpful to avoid making multiple requests for the same data.
 */
class PromiseCache {
    private cache: Record<string, Promise<any>> = {};
    private disabled = false;

    /**
     * Gets a promise from the cache, or undefined if it doesn't exist.
     */
    public get(key: object): Promise<any> | undefined {
        if (this.disabled) return undefined;
        const keyString = JSON.stringify(key);
        return this.cache[keyString];
    }

    /**
     * Sets a promise in the cache and returns it.
     */
    public set(key: object, promise: Promise<any>): Promise<any> {
        if (this.disabled) return promise;
        const keyString = JSON.stringify(key);
        this.cache[keyString] = promise;
        return promise;
    }

    /**
     * Some environments don't want workflows to be cached. An example is a server
     * that doesn't launch a fresh instance per request. This method allows disabling
     * caching in a transparent way.
     */
    public disable(value: boolean): void {
        this.disabled = value;
    }
}

const promiseCache = new PromiseCache();
export default promiseCache;
